/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Bookmark } from '../models/Bookmark';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BookmarksService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create a bookmark for a video
     * @returns any Bookmark created
     * @throws ApiError
     */
    public postVideosBookmarks({
        videoId,
        requestBody,
    }: {
        videoId: string,
        requestBody?: {
            label: string;
            timeSeconds: number;
            notes?: string;
            thumbnailDataUrl?: string;
            drawingData?: string;
        },
    }): CancelablePromise<{
        bookmark: Bookmark;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/videos/{videoId}/bookmarks',
            path: {
                'videoId': videoId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Video not found`,
            },
        });
    }

    /**
     * List bookmarks for a video
     * @returns any List of bookmarks
     * @throws ApiError
     */
    public getVideosBookmarks({
        videoId,
    }: {
        videoId: string,
    }): CancelablePromise<{
        bookmarks: Array<Bookmark>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/videos/{videoId}/bookmarks',
            path: {
                'videoId': videoId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Update a bookmark
     * @returns any Bookmark updated
     * @throws ApiError
     */
    public patchVideosBookmarks({
        videoId,
        bookmarkId,
        requestBody,
    }: {
        videoId: string,
        bookmarkId: string,
        requestBody?: {
            label?: string;
            timeSeconds?: number;
            notes?: string;
            thumbnailDataUrl?: string;
            drawingData?: string;
        },
    }): CancelablePromise<{
        bookmark: Bookmark;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/videos/{videoId}/bookmarks/{bookmarkId}',
            path: {
                'videoId': videoId,
                'bookmarkId': bookmarkId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }

    /**
     * Delete a bookmark
     * @returns any Bookmark deleted
     * @throws ApiError
     */
    public deleteVideosBookmarks({
        videoId,
        bookmarkId,
    }: {
        videoId: string,
        bookmarkId: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/videos/{videoId}/bookmarks/{bookmarkId}',
            path: {
                'videoId': videoId,
                'bookmarkId': bookmarkId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }

}
